<template>
    <div class="footer">
        <div class="web">
            <el-row :gutter="50">
                <el-col :span="8" style="position: relative;">
                    <div class="footerBanner">
                        <img src="@/assets/footerBanner.png" alt="">
                    </div>
                    <div class="footerTitle" style="text-align: center;width: 362px;">运营中心</div>
                    <div class="footerContent">
                        <div>华南：广州市白云区嘉禾望岗量子创造空间三号楼252室</div>
                        <div>华东：上海市杨浦区隆昌路619号1-B207室</div>
                        <div>华中：河南省信阳市固始县中山大街中山公寓西侧约80米童橙教育</div>
                        <div>华北：北京市丰台区高立庄616号新华国际中心&nbsp;C415</div>
                        <div>西南：广西省南宁市西乡塘区大学东路31号时代天骄A座1329室</div>
                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="footerTitle" style="margin-left: 28px;">联系我们</div>
                    <div class="footerContent">
                        <div>中园学院（广州）有限公司</div>
                        <div>公司地址：广州市花都区建设北路107-17号</div>
                        <div>
                            <span class="spanWid">商务合作：13660738820（罗总）</span>
                            <span>投诉举报：18650036063（林总）</span>
                        </div>
                        <div>
                            <span class="spanWid">校企合作：13480222786（罗老师）</span>
                            <span>招聘服务：13428864539（刘老师）</span>
                        </div>
                        <div>
                            <span class="cooperation">©2018——2023&nbsp;&nbsp;&nbsp;中园学院（广州）有限公司&nbsp;&nbsp;&nbsp;版权所有</span>
                            <span>违法和不良信息举报邮箱：zhongyuanxueyuan@sohu.com</span>
                        </div>
                        <div>
                            <span @click="keepOnRecord" class="keepOnRecord">备案号：粤ICP备19032445号</span>
                            <span class="certificate" @click="imgOpen('yingyezhizhaoImg')">营业执照</span>
                            <span class="certificate" @click="imgOpen('renliziyuanImg')">人力资源服务许可证</span>
                            <span class="certificate" @click="imgOpen('ruanjianImg')">软件著作权证书</span>
                            <span class="certificate" @click="imgOpen('shangbiaoImg')">商标注册证</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div class="clearfix codeBox">
                <div class="fl code">
                    <img src="@/assets/xiaochengxu.jpg" alt="">
                    <p>幼聘网小程序</p>
                </div>
                <div class="fr code">
                    <img src="@/assets/gongzhonghao.jpg" alt="">
                    <p>幼聘网公众号</p>
                </div>
            </div>
        </div>

        <el-dialog
            :visible.sync="imgDialog"
            width="30%"
            :before-close="imgDialogClose">
            <img class="certificateImg" :src="showImg" alt="" @click="openImg">
        </el-dialog>
    </div>
</template>

<script>
    import yingyezhizhao from '@/assets/yingyezhizhao.jpg'
    import renliziyuan from '@/assets/renliziyuan.jpg'
    import ruanjian from '@/assets/ruanjian.jpg'
    import shangbiao from '@/assets/shangbiao.jpg'
    export default {
        data() {
            return {
                yingyezhizhaoImg: yingyezhizhao,
                renliziyuanImg: renliziyuan,
                ruanjianImg: ruanjian,
                shangbiaoImg: shangbiao,
                imgDialog: false,
                showImg: ''
            }
        },
        methods: {
            // 备案号跳转
            keepOnRecord() {
                window.open('https://beian.miit.gov.cn/')
            },

            // 证件关闭
            imgDialogClose() {
                this.imgDialog = false
                this.showImg = ''
            },

            // 证件打开
            imgOpen(img) {
                this.imgDialog = true
                this.showImg = this[img]
            },

            // 打开新标签图片
            openImg() {
                window.open(this.showImg)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer {
        margin-top: 20px;
        background: rgba(242, 242, 242, 1);
        color: rgb(141, 146, 161);
        font-size: 14px;
        padding-top: 80px;
        padding-bottom: 20px;
        .footerBanner {
            position: absolute;
            left: 20px;
            top: -70px;
            img {
                width: 145px;
            }
        }
        .footerTitle {
            font-weight: bold;
            font-size: 20px;
        }
        .footerContent {
            padding-top: 30px;
            >div {
                padding-top: 20px;
            }
            >div:first-child {
                padding-top: 0;
            }
            .cooperation {
                color: rgb(169, 169, 169);
                margin-right: 30px;
            }
            .spanWid {
                display: inline-block;
                width: 260px;
            }
        }
        .bottom {
            text-align: center;
            padding-top: 30px;
            color: rgb(169, 169, 169);
            font-size: 14px;
        }
    }

    .keepOnRecord {
        color: rgb(120, 120, 120);
        cursor: pointer;
        margin-left: 69px;
    }
    .certificate {
        margin-left: 25px;
        cursor: pointer;
    }
    .web {
        position: relative;
        .codeBox {
            position: absolute;
            right: 0;
            top: 0;
            .code {
                width: 117px;
                text-align: center;
                >p {
                    padding-top: 10px;
                }
                >img {
                    border-radius: 8px;
                    width: 100%;
                    height: 117px;
                }
            }
            .code:first-child {
                margin-right: 50px;
            }
        }
    }

    .certificateImg {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue